export default {
  承建商信息: "承建商信息",
  社会统一信用代码: "社会统一信用代码",
  请输入社会统一信用代码: "请输入18位的社会统一信用代码",
  请输入正确的社会统一信用代码: "请输入18位的社会统一信用代码",
  施工单位名称: "承建商单位名称",
  请输入施工单位名称: "请输入承建商单位名称",
  施工负责人: "承建商负责人",
  请输入施工负责人: "请输入承建商负责人",
  施工负责人联系电话: "承建商负责人联系电话",
  请输入正确的手机号码: "请输入正确的手机号码",
  请输入施工负责人联系电话: "请输入承建商负责人联系电话",
  值守电工: "值守电工姓名",
  请输入值守电工: "请输入值守电工",
  值守电工联系电话: "值守电工联系电话",
  请输入值守电工联系电话: "请输入值守电工联系电话",
  邮箱: "邮箱",
  请输入正确的邮箱: "请输入正确的邮箱",
  请输入邮箱: "请输入邮箱",
  传真: "传真",
  请输入传真: "请输入传真",
  "用于接收报图审核结果，请填写正确的邮箱":
    "用于接收报图审核结果，请填写正确的邮箱",
  "施工单位和现场实际实施单位为同一个单位?":
    "承建商单位和现场实施施工单位为同一个单位?",
  是: "是",
  否: "否",
  施工负责人身份证:'现场施工负责人身份证',
  值守电工身份证:'值守电工身份证',
  值守电工电工证:'值守电工电工证',
  公司名称: "施工单位名称",
  联系人: "现场施工负责人",
  联系电话: "现场施工负责人联系电话",
  施工单位简称: "承建商单位简称",
  请输入施工单位简称: "请输入承建商单位简称",
  地址: "承建商单位地址",
  请输入地址: "请输入承建商单位地址",
  固定电话: "固定电话",
  请输入固定电话: "请输入固定电话",
  邮箱验证码: "邮箱验证码",
  请输入邮箱验证码: "请输入邮箱验证码",
  请输入正确的邮箱验证码: "请输入正确的邮箱验证码",
  校验失败:"校验失败",
  验证码不正确: "验证码不正确",
  请先输入邮箱: "请先输入邮箱",
  请输入公司名称: "请输入施工单位名称",
  请输入电话:"请输入施工负责人联系电话",
  请输入负责人:"请输入施工负责人",
  获取验证码:'获取验证码'
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsProducerInfo.js